import { Export } from '@carbon/icons-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Button,
} from '@/components/ui';
import './pwa-install-modal.scss';

interface PwaInstallModalProps {
  isOpen: boolean;
  onClose: () => void;
  isIOS: boolean;
  canInstall: boolean;
  onInstall: () => Promise<void>;
}

const PwaInstallModal = ({
  isOpen,
  onClose,
  isIOS,
  canInstall,
  onInstall,
}: PwaInstallModalProps) => {
  const handleInstallClick = async () => {
    await onInstall();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="pwa-install-modal">
        <DialogHeader>
          <DialogTitle className="pwa-install-title">
            Welcome to Qluu!
          </DialogTitle>
        </DialogHeader>

        <div className="pwa-install-body">
          <p className="pwa-install-subtitle">
            Your company's driver feedback tool
          </p>

          <p className="pwa-install-description">
            Install Qluu on your mobile device for faster access and offline
            support
          </p>

          {isIOS ? (
            <div className="pwa-install-ios">
              <div className="pwa-install-ios-steps">
                <p className="pwa-install-ios-label">Steps to Install:</p>
                <div className="pwa-install-ios-step">
                  <span className="pwa-install-step-number">1.</span>
                  <span>Tap the </span>
                  <Export className="pwa-install-share-icon" />
                  <span> Share icon</span>
                </div>
                <div className="pwa-install-ios-step">
                  <span className="pwa-install-step-number">2.</span>
                  <span>Tap "Add to Home Screen"</span>
                </div>
              </div>
            </div>
          ) : canInstall ? (
            <div className="pwa-install-android">
              <Button
                size="small"
                variant="basic-primary"
                className="pwa-install-button"
                onClick={handleInstallClick}
              >
                Install Qluu app
              </Button>
            </div>
          ) : (
            <div className="pwa-install-ios">
              <div className="pwa-install-ios-steps">
                <p className="pwa-install-ios-label">Steps to Install:</p>
                <div className="pwa-install-ios-step">
                  <span className="pwa-install-step-number">1.</span>
                  <span>Tap the menu icon (⋮) in your browser</span>
                </div>
                <div className="pwa-install-ios-step">
                  <span className="pwa-install-step-number">2.</span>
                  <span>Tap "Add to Home Screen"</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { PwaInstallModal };
